import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.333 4.667h-3.206l.534-3.91a.667.667 0 0 0-1.322-.18l-.557 4.09H6.127l.534-3.91a.667.667 0 0 0-1.322-.18l-.557 4.09H1.333a.667.667 0 0 0 0 1.333H4.6l-.545 4H.667a.667.667 0 0 0 0 1.334h3.206l-.534 3.91a.667.667 0 0 0 1.322.18l.557-4.09h4.655l-.534 3.91a.667.667 0 0 0 1.322.18l.557-4.09h3.449a.667.667 0 0 0 0-1.334H11.4l.545-4h3.388a.667.667 0 1 0 0-1.333M10.055 10H5.4l.545-4H10.6z"
    }, null, -1)
  ]))]))
}
export default { render: render }